import { render } from "./Header.vue?vue&type=template&id=ed558de2"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/header/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed558de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed558de2', __exports__)) {
    api.reload('ed558de2', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=ed558de2", () => {
    api.rerender('ed558de2', render)
  })

}


export default __exports__